import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M3.87 5.642a1.07 1.07 0 0 1 0-1.511l2.807-2.808a1.07 1.07 0 0 1 1.512 0l2.807 2.808a1.069 1.069 0 1 1-1.512 1.511l-.982-.982v9.26a1.069 1.069 0 1 1-2.138 0V4.66l-.983.982a1.07 1.07 0 0 1-1.512 0M12.87 10.357a1.07 1.07 0 0 0 0 1.512l2.807 2.808a1.07 1.07 0 0 0 1.512 0l2.807-2.808a1.069 1.069 0 1 0-1.512-1.512l-.982.983V2.079a1.07 1.07 0 0 0-2.138 0v9.261l-.983-.983a1.07 1.07 0 0 0-1.512 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }